import Approvals from './ApprovalsContainer';

export default Approvals;
